import {dateTime} from "services/date";
import {Building} from "../../../types/Building";

/**
 * Transform the given building by deserializing object properties
 *
 * @internal
 * @param building
 */
export default function deserializeBuilding(building: any): Building {
    building.created_at = dateTime(building.created_at)
    building.updated_at = dateTime(building.updated_at)

    return building;
}